
import Highcharts from 'highcharts';
import DrilldownModule from "highcharts/modules/drilldown";
import Chart from "highcharts-react-official";
import { formatarParaMoedaBRL } from "../../utils";

DrilldownModule(Highcharts);
export default function BarComparationChart({
  series,
  seriesComparation,
  categories,
  title
}: {
    series: any,
    seriesComparation: any,
    categories: any,
    title:string
}) {
 
  const options = {
    chart: {
      type: 'column',
      height: 650,
  },
  title: {
      text: title
  },
  credits: {
    enabled: false
  },
  subtitle: {
      text: 'Clique nas colunas para mais detalhes'
  },
  accessibility: {
      announceNewData: {
          enabled: true
      }
  },
  xAxis: {
      categories: categories
  },
  yAxis: {
      title: {
          text: 'Valor'
      }

  },
  legend: {
      enabled: true
  },
  plotOptions: {
    column: {
        grouping: false,
        shadow: false,
        borderWidth: 0
    },
      series: {
          borderWidth: 0,
          
          dataLabels: {
              enabled: true,
              formatter: function (this: Highcharts.TooltipFormatterContextObject) {
                return formatarParaMoedaBRL(Number(this.point.y));
            }
          }
      }
  },

  tooltip: {
      formatter: function (this: Highcharts.TooltipFormatterContextObject) {
        return  '<span style="color:'+this.color+'">'+this.point.series.name+'</span>: ' +
        '<b>'+formatarParaMoedaBRL(Number(this.point.y))+'</b> <br/>';
    }
      
     
  },

  series: [{
        name: seriesComparation.name,
        color: 'rgba(24, 52, 98,0.95)',
        data: seriesComparation.data,
        
        pointPadding: 0.3,
        pointPlacement: 0
    }, {
        name: series.name,
        color: 'rgba(76,99,182,1)',
        data: series.data,
        
         pointPadding: 0.4,
        pointPlacement: 0


    }]
  };
  
  return (
    <Chart highcharts={Highcharts} options={options} />
  )
}
